import * as Types from "../actionTypes/socketTypes";

export const initialState = {
  viewerSocket: null,
};

const socketReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SOCKET_VIEWER_INFO:
      return {
        ...state,
        viewerSocket: action.data,
      };
    default:
      return state;
  }
};
export default socketReducer;
